<template>
  <div>
    <requirement-filter @change="onChange" />
    <br />
    <req-dev-time-rank :filter-form="filterForm" />
    <br />
    <req-add-rem-trend :filter-form="versionFilterForm" />
  </div>
</template>
<script>
import moment from 'moment';
import RequirementFilter from '@/pages/data/requirement/components/RequirementFilter';
import ReqDevTimeRank from '@/pages/data/requirement/components/ReqDevTimeRank';
// import ReqDevTimeAverage from '@/pages/data/requirement/components/ReqDevTimeAverage';
// import VersionFilter from '@/pages/data/requirement/components/VersionFilter';
import ReqAddRemTrend from '@/pages/data/requirement/components/ReqAddRemTrend.vue';

export default {
  components: { RequirementFilter, ReqDevTimeRank, ReqAddRemTrend },
  data() {
    return {
      filterForm: {
        begin_date: moment().subtract(1, 'month').add(1, 'day').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD')
      },
      versionFilterForm: {
        version_id: null
      }
    };
  },
  methods: {
    onChange(checkedDate, checkedProjects) {
      this.filterForm = {
        begin_date: checkedDate[0].format('YYYY-MM-DD'),
        end_date: checkedDate[1].format('YYYY-MM-DD'),
        projects: checkedProjects
      };
    },
    onVersionChange(checkedVersion) {
      this.versionFilterForm = {
        version_id: checkedVersion
      };
    }
  }
};
</script>
